import React, { createContext, useContext, useState } from 'react';

import {useAppCtx} from "./AppCtx";
import {successStatus, errorStatus} from "../ctx/AppStatus";
import {CodeData} from '../domain/CodeData';
import {codelist} from "../gateway/CodeService";

const CodeContext = createContext();

export function CodeCtxProvider({ children }) {
    const {updateAppStatus} = useAppCtx();
    const [code, setCode] = useState( new CodeData() ); // Initialize Code with an empty array
    const [codeLoadCount, setCodeLoadCount] = useState(0);
    const [codeLoadTs, setCodeLoadTs] = useState(null);

    const loadCodes = () => {
        codelist().then(call => {
            if (call.isSuccess && call.result) {
                setCode(new CodeData(call.result));
                setCodeLoadCount((prev) => prev + 1);
                setCodeLoadTs(Date.now());
                updateAppStatus('code', successStatus(`Code data ${call.result.length} records successfully loaded.`, call.elapsed));
            } else {
                updateAppStatus('code', errorStatus(`Code data load failed with error: ${call.result}`, call.elapsed));
            }
        });
    }

    const staleloadCodes = (timeout = 6 * 60 * 1000) => {
        if (!codeLoadTs || (Date.now() - codeLoadTs) > timeout) {
            loadCodes();
        }
    }

    const lazyloadCodes = () => {
        if (code.isEmpty()) {
            loadCodes()
        }
    }

    return (
        <CodeContext.Provider value={{ code, loadCodes, staleloadCodes, lazyloadCodes, codeLoadCount, codeLoadTs }}>
            {children}
        </CodeContext.Provider>
    );
}

export const useCodeCtx = () => useContext(CodeContext);
